<template>
  <div>
    <b-card style="height:calc(100vh - 275px); overflow-y:auto;">
      <h4>Scoring</h4>
      <b-form-group label="Scoring Options">
        <div style="display:flex;">
          <b-form-checkbox
            :disabled="searchPage"
            v-model="$store.state.priConfigrationforms.countryRules.cpiIndex"
          >CPI Index&nbsp; &nbsp;</b-form-checkbox>
          <b-form-checkbox
            :disabled="searchPage"
            v-model="$store.state.priConfigrationforms.countryRules.activeSanctions"
          >Active Sanctions&nbsp; &nbsp;</b-form-checkbox>
        </div>
      </b-form-group>
      <div>
        <b-row>
          <b-col cols="6" v-if="$store.state.priConfigrationforms.countryRules.activeSanctions">
            <h4>Active Sanctions Scoring</h4>
            <b-form-group description label>
              <b-form-input
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.countryRules.activeSanctionsScoring"
                id="input-1"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6" v-if="$store.state.priConfigrationforms.countryRules.cpiIndex">
            <h4>CPI Index Score Rating</h4>
            <b-table-simple class="table">
              <b-thead>
                <b-tr>
                  <b-th scope="col">Risk</b-th>
                  <b-th scope="col">From</b-th>
                  <b-th scope="col">To</b-th>
                  <b-th scope="col">Score</b-th>
                </b-tr>
              </b-thead>

              <b-tbody>
                <b-tr>
                  <b-td>
                    <b-badge variant="success">Low</b-badge>
                  </b-td>
                  <b-td>1</b-td>
                  <b-td>
                    <b-form-input
                      :disabled="searchPage"
                      v-model="$store.state.priConfigrationforms.countryRules.lowerUpperLimit"
                      onkeydown="return event.keyCode !== 69"
                      type="number"
                    ></b-form-input>
                  </b-td>
                  <b-td>
                    <b-form-input
                      :disabled="searchPage"
                      onkeydown="return event.keyCode !== 69"
                      type="number"
                      min="1"
                      max="100"
                    ></b-form-input>
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-td>
                    <b-badge variant="warning">Medium</b-badge>
                  </b-td>
                  <b-td>{{parseInt($store.state.priConfigrationforms.countryRules.lowerUpperLimit)+1}}</b-td>
                  <b-td>
                    <b-form-input
                      :disabled="searchPage"
                      onkeydown="return event.keyCode !== 69"
                      v-model="$store.state.priConfigrationforms.countryRules.mediumUpperLimit"
                      type="number"
                    ></b-form-input>
                  </b-td>
                  <b-td>
                    <b-form-input
                      :disabled="searchPage"
                      onkeydown="return event.keyCode !== 69"
                      type="number"
                    ></b-form-input>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td>
                    <b-badge variant="danger">High</b-badge>
                  </b-td>
                  <b-td>{{parseInt($store.state.priConfigrationforms.countryRules.mediumUpperLimit)+1}}</b-td>
                  <b-td>100</b-td>
                  <b-td>
                    <b-form-input
                      onkeydown="return event.keyCode !== 69"
                      :disabled="searchPage"
                      type="number"
                      min="1"
                      max="100"
                    ></b-form-input>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "CountryComponent",
  data() {
    return {
      countryScoringOptions: [
        { text: "CPI Index", value: "1" },
        { text: "Active Sanctions", value: "2" }
      ]
    };
  },
  props: {
    searchPage: Boolean
  }
};
</script>